import { useState, useRef } from "react";
import { message } from "antd";
import React from "react";
import { TextService } from "../../Services/TextService";
import { WebApiMemberDtoMemberDto, WebApiServicesDataTransferObjectsGroupServiceGroupMemberDto } from "../../Repository/eventbookyapi";
import { AutoCompleteType } from "../../Types/AutoCompleteType";

const dropdownStyles: React.CSSProperties = {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    border: "1px solid #d9d9d9",
    borderRadius: 6,
    boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
    zIndex: 9999,
    maxHeight: 300,
    overflowY: "auto",
    marginTop: 2,
};

const optionStyles: React.CSSProperties = {
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: 14,
    borderBottom: "1px solid #f0f0f0",
};

export const MemberAutocomplete = (props: any) => {
    const [value, setValue] = useState("");
    const [allMembers, setAllMembers] = useState([] as WebApiMemberDtoMemberDto[]);
    const [options, setOptions] = useState<{ label: string; value: any }[]>([]);
    const [open, setOpen] = useState(false);
    const GetText = TextService.GetText;
    const containerRef = useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        setAllMembers(props.members);
    }, [props.members]);

    const getSuggestions = (searchValue: string) => {
        const inviteAutoCompleteSuggestion: any[] = [];
        const filteredMembers = allMembers.filter((itemData: WebApiServicesDataTransferObjectsGroupServiceGroupMemberDto) => {
            return itemData.email != "" && (itemData.firstName?.toLocaleLowerCase().startsWith(searchValue) ||
                itemData.lastName?.toLocaleLowerCase().startsWith(searchValue) ||
                (itemData.firstName + " " + itemData.lastName).toLocaleLowerCase().startsWith(searchValue) ||
                itemData.uniqueId?.startsWith(searchValue) ||
                itemData.email?.toLocaleLowerCase().startsWith(searchValue));
        });
        filteredMembers.forEach((member: WebApiServicesDataTransferObjectsGroupServiceGroupMemberDto) => {
            inviteAutoCompleteSuggestion.push({
                label: member.email
                    ? member.firstName + " " + member.lastName + " <" + member.email + ">"
                    : member.firstName + " " + member.lastName,
                value: member.memberId,
            });
        });
        return inviteAutoCompleteSuggestion;
    };

    // Native input handler — works reliably on iOS/iPadOS Safari
    const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
        const text = (e.target as HTMLInputElement).value;
        setValue(text);
        const result = getSuggestions(text.toLocaleLowerCase());
        setOptions(result);
        setOpen(result.length > 0 && text.length > 0);
    };

    const onMemberSelect = (id: any) => {
        const member = allMembers.find((e: WebApiMemberDtoMemberDto) => e.memberId === Number.parseInt(id));
        if (props.AutoCompleteType == AutoCompleteType.Email) {
            if (!member?.email && !member?.email2) {
                message.warning("Medlemmen saknar e-postadresser.");
                return;
            }
        }
        if (props.AutoCompleteType == AutoCompleteType.PhoneNumber) {
            if (!member?.phoneNumber) {
                message.warning("Medlemmen saknar telefonummer.");
                return;
            }
        }
        setValue("");
        setOptions([]);
        setOpen(false);
        props.onAutoCompleteSelect(member);
    };

    const handleBlur = () => {
        // Delay closing so that a tap on an option registers first
        setTimeout(() => setOpen(false), 200);
    };

    return (
        <div ref={containerRef} style={{ width: "100%", maxWidth: 400, position: "relative", ...props.style }}>
            <input
                type="text"
                value={value}
                onInput={handleInput}
                onChange={(e) => setValue(e.target.value)}
                onFocus={() => value && options.length > 0 && setOpen(true)}
                onBlur={handleBlur}
                placeholder={GetText("MemberAutocomplete__Placeholder")}
                style={{
                    width: "100%",
                    height: 32,
                    padding: "4px 11px",
                    fontSize: 14,
                    border: "1px solid #d9d9d9",
                    borderRadius: 6,
                    outline: "none",
                    boxSizing: "border-box",
                }}
            />
            {open && options.length > 0 && (
                <div style={dropdownStyles}>
                    {options.map((option) => (
                        <div
                            key={option.value}
                            style={optionStyles}
                            // onMouseDown prevents blur from firing before the tap registers on iOS
                            onMouseDown={(e) => e.preventDefault()}
                            onTouchEnd={(e) => { e.preventDefault(); onMemberSelect(option.value); }}
                            onClick={() => onMemberSelect(option.value)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};